import React, { useState } from "react";

export const Searchbar = (props) => {
  const { filterOptions, keyToFilter } = props;

  const [inputValue, setInputValue] = useState("");
  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
  };

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <input
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        style={{ width: "90%" }}
        placeholder="Buscar"
      />
      {inputValue.length > 0 && (
        <div
          style={{
            maxHeight: 300,
            overflowY: "auto",
            border: "1px solid black",
            margin: 10,
            width: "90%",
            padding: 5,
          }}
        >
          <ul>
            {filterOptions &&
              filterOptions
                .filter((item) =>
                  item[keyToFilter]
                    .toLowerCase()
                    .includes(inputValue.toLowerCase()),
                )
                .map((item, index) => (
                  <a key={index} href={item.url}>
                    · {item[keyToFilter]}
                  </a>
                ))}
          </ul>
        </div>
      )}
    </div>
  );
};
